// Severity-tinted alert card used by /executive predictive-alerts panel,
// /notifications, and gate-review conflict callouts.

const SEVERITY_LABEL = {
  red: 'CRITICAL',
  amber: 'WATCH',
  blue: 'NOTICE',
  green: 'CLEAR',
  sage: 'CLEAR',
};

export function AlertCard({
  severity = 'amber',
  title,
  body,
  chips = [],
  actionLabel,
  onAction,
  meta,
  onClick,
  label,
  statusLabel,
  statusTone = 'blue',
  className = '',
  testId,
  dataState,
  secondaryActions,
}) {
  const cls = `alert-card alert-${severity} ${onClick ? 'interactive' : ''} ${className}`.trim();
  const chipLabel = label || SEVERITY_LABEL[severity] || severity.toUpperCase();
  return (
    <article
      className={cls}
      data-testid={testId}
      data-notification-state={dataState}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : -1}
    >
      <span className="alert-accent" aria-hidden />
      <div className="alert-body">
        <header className="alert-header">
          <span className="alert-header-left">
            <span
              className={`chip ${severity === 'amber' ? 'amber' : severity === 'red' ? 'red' : severity === 'green' ? 'sage' : 'blue'} sm`}
            >
              <span className="chip-dot pulse" /> {chipLabel}
            </span>
            {statusLabel ? (
              <span className={`chip ${statusTone} sm alert-state-chip`}>{statusLabel}</span>
            ) : null}
          </span>
          {meta ? <span className="muted small">{meta}</span> : null}
        </header>
        <h4 className="alert-title">{title}</h4>
        {body ? <p className="alert-text">{body}</p> : null}
        {chips.length ? (
          <div className="row wrap" style={{ gap: 6 }}>
            {chips.map((c, i) => (
              <span key={i} className="chip outline sm">
                {c}
              </span>
            ))}
          </div>
        ) : null}
        {actionLabel || secondaryActions ? (
          <div className="alert-actions">
            {actionLabel ? (
              <button
                className="btn link"
                onClick={(e) => {
                  e.stopPropagation();
                  onAction && onAction();
                }}
              >
                {actionLabel} →
              </button>
            ) : null}
            {secondaryActions}
          </div>
        ) : null}
      </div>
    </article>
  );
}
